/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import { Col, Modal, Row } from 'react-bootstrap';
import Badge from 'components/base/Badge';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import CustomModal from 'components/custom/modal/CustomModal';
import { formatDate } from 'services/utils';
import LabelInput from 'components/custom/forms/LabelInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import postData from 'services/postData';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import { useAlert } from 'providers/AlertModalProvider';
import PageLoader from 'components/custom/animate-component/PageLoader';

const LeaveReviewModal = ({
  show,
  handleClose,
  action = true,
  data,
  handleRefresh
}) => {
  const [isSwiperVisible, setSwiperVisible] = useState(false);
  const [confirmation, setConfirmation] = useState('');
  const [note, setNote] = useState('');
  const [loading, loadingText, handleLoading] = useManagePageLoading();
  const { showAlert } = useAlert();
  const {
    leave_id,
    leave_type,
    user_type,
    user_email,
    reason,
    user_mobile,
    leave_from,
    leave_to,
    remainLeave,
    user_name,
    user_img_upload,
    status,
    employee_department,
    employee_designation,
    admin_comment,
    employee_name,
    driver_name,
    employee_email,
    driver_email,
    employee_mobile,
    driver_mobile,
    employee_image,
    driver_image
  } = data || {};

  const [no_of_days, setNoOfDays] = useState(0);

  const handleConfirmAction = async values => {
    handleLoading(
      true,
      `${values.status === 'Approve' ? 'Approving' : 'Rejecting'} leave request`
    );
    const request = await postData(
      values,
      apiEndpoints.leave.leaveAcceptRejeact(leave_id)
    );

    if (request.status) {
      handleLoading(false);
      handleRefresh();
      setSwiperVisible(false);
      handleClose();
      showAlert({
        variant: 'success',
        message: `The approval for "${leave_type}" has been successfully ${values.status}.`
      });
    } else {
      handleLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to ${values.status} the approval for "${leave_type}". Please try again later.`
      });
    }
  };

  const formikApprove = useFormik({
    initialValues: {
      admin_comment: '',
      status: 'Approved'
    },
    validationSchema: Yup.object({
      admin_comment: Yup.string()
    }),
    onSubmit: values => {
      handleConfirmAction(values);
    }
  });

  const formikDecline = useFormik({
    initialValues: {
      admin_comment: '',
      status: 'Declined'
    },
    validationSchema: Yup.object({
      admin_comment: Yup.string().required('Note is required')
    }),
    onSubmit: values => {
      handleConfirmAction(values);
    }
  });

  useEffect(() => {
    if (leave_from && leave_to) {
      const fromDate = new Date(leave_from);
      const toDate = new Date(leave_to);
      const timeDiff = Math.abs(toDate - fromDate);
      const noOfDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      setNoOfDays(noOfDays + 1);
    }
  }, [leave_from, leave_to]);

  const handleActionClick = data => {
    setConfirmation(data);
    setSwiperVisible(true);
  };

  // const handleConfirmAction = actionType => {
  //   if (actionType === 'reject' && !note.trim()) {
  //     alert('Please enter a note for rejection.');
  //     return;
  //   }

  //   console.log(`Action: ${actionType}, Note: ${note}`);
  //   setSwiperVisible(false);
  //   handleClose();
  //   setNote('');
  // };

  const handelConfirmCancel = item => {
    setSwiperVisible(item);
    setNote('');
  };
  return (
    <CustomModal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body className="pt-2 ms-3 mt-2 position-relative">
        <>
          <div className="d-flex align-items-center justify-content-between flex-column flex-sm-row">
            <Avatar
              size="3xl"
              src={user_type === 'Employee' ? employee_image : driver_image}
              className="me-3 order-1 order-sm-2 mb-3 mb-sm-0"
            />
            <div className="order-2 order-sm-1">
              <Col xs={12} sm="auto" className="flex-1">
                <div className="pt-1 mb-0 text-center text-sm-start">
                  <h4>
                    {user_type === 'Employee' ? employee_name : driver_name}
                  </h4>
                </div>
                <div className="d-flex gap-x-2 align-items-center flex-wrap">
                  <Link
                    to={`tel:{${user_type} === 'Employee' ? ${employee_mobile} : ${driver_mobile}}`}
                    className="d-flex align-items-center justify-content-center justify-content-sm-start gap-1"
                  >
                    <Icon
                      icon={'line-md:phone'}
                      className={''}
                      fontSize={'15px'}
                    />
                    <span>
                      {user_type === 'Employee'
                        ? employee_mobile
                        : driver_mobile}
                    </span>
                  </Link>
                  {user_email && (
                    <Link
                      to={`email: {${user_type} === 'Employee' ? ${employee_email} : ${driver_email}}`}
                      className="d-flex align-items-center justify-content-center justify-content-sm-start gap-1"
                    >
                      <Icon
                        icon={'oui:email'}
                        className={''}
                        fontSize={'14px'}
                      />
                      <span>
                        {user_type === 'Employee'
                          ? employee_email
                          : driver_email || '--'}
                      </span>
                    </Link>
                  )}
                </div>
                <div className="mt-1">
                  <p
                    className={`text-700 fs-9 me-2 mb-0 d-flex align-items-center gap-1`}
                  >
                    <p className="fs-9 me-2 mb-0 pe-lg-2 border-end-lg border-300">
                      <Badge
                        iconPosition="start"
                        variant="phoenix"
                        bg="success"
                      >
                        {employee_designation || '--'}
                      </Badge>
                    </p>
                    <p className="fs-9 me-2 mb-0 pe-lg-2 border-end-lg border-300">
                      {employee_department || '--'}
                    </p>
                    {remainLeave || '--'} Remaining leave
                  </p>
                </div>
              </Col>
            </div>
          </div>

          <div className="border-bottom mt-3 mb-2"></div>
          {!isSwiperVisible ? (
            <Row>
              <Col xs={12}>
                <div className="d-flex align-items-center mb-1">
                  <h5 className="mb-0 fw-medium">User Type :</h5>
                  <span className="ms-2">
                    <Badge iconPosition="start" variant="phoenix" bg="info">
                      {user_type}
                    </Badge>
                  </span>
                </div>
              </Col>
              <Col xs={12}>
                <div className="d-flex align-items-center mb-1">
                  <h5 className="mb-0 fw-medium">Application For :</h5>
                  <span className="ms-2">
                    <Badge iconPosition="start" variant="phoenix" bg="primary">
                      {leave_type}
                    </Badge>
                  </span>
                </div>
              </Col>
              <Col xs={12}>
                <div className="d-flex align-items-center mb-1">
                  <h5 className="mb-0 fw-medium">From Date :</h5>
                  <p className="text-800 mb-0 fs-8 ms-2 ">
                    {formatDate(leave_from, 'DD MMM YYYY - HH:mm A')}
                  </p>
                </div>
              </Col>
              <Col xs={12}>
                <div className="d-flex align-items-center mb-1">
                  <h5 className="mb-0 fw-medium">To Date :</h5>
                  <p className="text-800 mb-0 fs-8 ms-2 ">
                    {formatDate(leave_to, 'DD MMM YYYY - HH:mm A')}
                  </p>
                </div>
              </Col>
              <Col xs={12}>
                <div className="d-flex align-items-center mb-1">
                  <h5 className="mb-0 fw-medium">No. of Days :</h5>
                  <p className="text-800 mb-0 fs-8 ms-2 ">{no_of_days}</p>
                </div>
              </Col>
              <Col xs={12}>
                <div className="d-flex align-items-center mb-1">
                  <h5 className="mb-0 fw-medium">Leave Reason :</h5>
                </div>
                <p className="text-800 mb-0 fs-8 p-2 border rounded-2">
                  <span className="ms-1">{reason}</span>
                </p>
              </Col>
              {status !== 'Pending' && (
                <>
                  <Col xs={12} className="mt-2 border-top border-200 pt-1">
                    <div className="d-flex align-items-center mb-1">
                      <h5 className="mb-0 fw-medium">Request :</h5>
                      <span className="ms-2">
                        <Badge
                          iconPosition="start"
                          variant="phoenix"
                          bg={status === 'Approved' ? 'success' : 'danger'}
                        >
                          {status}
                        </Badge>
                      </span>
                    </div>
                  </Col>
                  {/* <Col xs={12}>
                    <div className="d-flex align-items-center mb-1">
                      <h5 className="mb-0 fw-medium">Note :</h5>
                    </div>
                    <p
                      className={`text-800 mb-0 fs-8 p-2 border rounded-2 ${status === 'Approve' ? 'border-success' : 'border-danger'}`}
                    >
                      <span className="ms-1">{admin_comment}</span>
                    </p>
                  </Col> */}
                </>
              )}
            </Row>
          ) : (
            <div>
              <div className="p-2">
                {/* <h5>Note:</h5> */}
                {confirmation == 'accept' ? (
                  <Row>
                    <Col xs={12} className="mt-2">
                      <LabelInput
                        errorProps={{ tooltip: false }}
                        controlId={'admin_comment'}
                        label="Note"
                        inputProps={{ as: 'textarea' }}
                        formik={formikApprove}
                        // required
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col xs={12} className="mt-2">
                      <LabelInput
                        errorProps={{ tooltip: false }}
                        controlId={'admin_comment'}
                        label="Note"
                        inputProps={{ as: 'textarea' }}
                        formik={formikDecline}
                        required
                      />
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          )}
        </>
      </Modal.Body>

      <Modal.Footer
        className={`d-flex justify-content-${action ? 'between' : 'center'} flex-wrap-reverse`}
      >
        {!isSwiperVisible ? (
          <>
            <Button variant="phoenix-secondary" onClick={handleClose}>
              {action ? 'Cancel' : 'Close'}
            </Button>
            {action && (
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  variant="phoenix-danger"
                  onClick={() => handleActionClick('reject')}
                >
                  Reject
                </Button>
                <Button
                  variant="phoenix-success"
                  onClick={() => handleActionClick('accept')}
                >
                  Accept
                </Button>
              </div>
            )}
          </>
        ) : (
          <>
            <Button
              variant="phoenix-secondary"
              onClick={() => handelConfirmCancel(false)}
            >
              Cancel
            </Button>
            {confirmation === 'reject' ? (
              <Button
                variant="phoenix-danger"
                onClick={formikDecline.handleSubmit}
              >
                Confirm Reject
              </Button>
            ) : (
              <Button
                variant="phoenix-success"
                onClick={formikApprove.handleSubmit}
              >
                Confirm Accept
              </Button>
            )}
          </>
        )}
      </Modal.Footer>

      <PageLoader loading={loading} loadingMessage={loadingText} />
    </CustomModal>
  );
};

export default LeaveReviewModal;
